import React from 'react';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Content,
  ContentVariants,
  Grid,
  GridItem,
  PageSection,
  Title,
} from '@patternfly/react-core';
import { ListIcon, TimesIcon } from '@patternfly/react-icons';
import { IssuesTable } from '../components/IssuesTable';
import { TodayTimeLog } from '../components/TodayTimeLog';
import { usePageHeaderVisibility } from '../hooks';
import './Dashboard.css';

const Dashboard: React.FC = () => {
  const { isHeaderVisible, hideHeader } = usePageHeaderVisibility('dashboard');

  return (
    <PageSection hasBodyWrapper={false}>
        {isHeaderVisible && (
          <div className="dashboard-header">
            <div className="page-header__title-row">
              <Title headingLevel="h1" size="2xl">
                Track your time
              </Title>
              <Button
                variant="plain"
                aria-label="Hide header"
                onClick={hideHeader}
                className="page-header__close-btn"
              >
                <TimesIcon />
              </Button>
            </div>
            <Content component={ContentVariants.p} className="dashboard-description">
              Select an issue to start tracking. Your work is automatically synced with Jira.
            </Content>
          </div>
        )}
        <Grid hasGutter>
          <GridItem span={8}>
            <Card isFullHeight>
              <CardHeader>
                <CardTitle>
                  <ListIcon /> Your issues
                </CardTitle>
              </CardHeader>
              <CardBody>
                <IssuesTable />
              </CardBody>
            </Card>
          </GridItem>
          <GridItem span={4}>
            <TodayTimeLog />
          </GridItem>
        </Grid>
    </PageSection>
  );
};

export { Dashboard };
